import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { FiMoreHorizontal, FiCalendar } from "react-icons/fi";
import { withRouter } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { TabletOrDesktop, Mobile } from "utils/responsive";
import { Dropdown } from "react-bootstrap";
import moment from "moment";
import GroupEdit from "components/Groups/GroupEditModal";
import Avatars from "components/Avatar/Avatars";
import DataTable from "components/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import { groupsService } from "services";
import { errorFormating } from "utils/utils";
import { withTranslation } from 'react-i18next';

class GroupList extends Component {
	constructor(props) {
		super(props);

		this.closeModal = this.closeModal.bind(this);
		this.getGroups = this.getGroups.bind(this);
	}

	closeModal() {
		this.props.hideModal();
	}

	getGroups() {
		if (typeof this.props.reloadGroups === "function") {
			this.props.reloadGroups();
		}
	}

	openEditGroupModal(group) {
		const title = group.is_multigroup ? this.props.t('groups.editMultigroup') : this.props.t('groups.editGroup');
		this.props.showModal(
			{
				open: true,
				title,
				style: { width: "400px" },
				content: (
					<GroupEdit
						group={group}
						getGroups={this.getGroups}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openViewGroupPage(group) {
		this.props.history.push("/groups/" + group.id);
	}

	goToPlanning = (group) => {
		const groupId = group.id;
		const startOfWeek = moment().startOf("isoWeek").format("YYYY-MM-DD");
		const endOfWeek = moment().endOf("isoWeek").format("YYYY-MM-DD");
		window.open(`/plans/${groupId}/${startOfWeek}@${endOfWeek}`, "_blank");
	};

	openDeleteGroupModal(idGroup) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('groups.deleteGroup'),
				style: { width: "400px" },
				message: this.props.t('groups.deleteConfirmation'),
				deleteAction: () => this.confirmDelete(idGroup),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	openAlertModal(message) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('groups.deleteError'),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	confirmDelete = async (idGroup) => {
		const response = await groupsService.remove(idGroup);

		if (!response.ok) {
			const textError = errorFormating(response);
			this.openAlertModal(
				textError.general ||
					textError.group ||
					textError.id ||
					this.props.t('groups.deleteError')
			);
		} else {
			this.getGroups();
			this.closeModal();
		}
	};

	getGroupList = (group) =>
		(group.groups || []).map((item) => (
			<li key={item.id} className="tag-default">
				{item.name}
			</li>
		));

	/** Totales y avatares para listado (misma lógica que antes). */
	getGroupEmployeeSummary(group) {
		let empleados_count = this.props.t('groups.noEmployeesAssigned');
		let total_employees = group.total_employees;
		let employees_avatars = group.employees ? [...group.employees] : [];

		if (group.is_multigroup) {
			employees_avatars = [];
			(group.groups || []).forEach((g) => {
				total_employees += g.total_employees;
				employees_avatars.push(...(g.employees || []));
			});
			if (employees_avatars.length > 2) {
				employees_avatars = employees_avatars.slice(0, 3);
			}
		}

		if (total_employees === 1) empleados_count = this.props.t('groups.oneEmployee');
		else if (total_employees > 1)
			empleados_count = `${total_employees} ${this.props.t('groups.employeesLabel')}`;

		return { employees_avatars, empleados_count, total_employees };
	}

	getEmptyRow = (isMobile) => (
		<tr>
			<td colSpan={isMobile ? 2 : 6} className="no-result">
				{this.props.t('groups.noGroupsCreated')}
			</td>
		</tr>
	);

	getDesktopColumns = () => [
		{
			key: "name",
			header: this.props.t('common.name'),
			className: "td-name",
			render: (group) => (
				<button
					type="button"
					className="btn-transparent btn-editable group-name"
					onClick={() => this.openViewGroupPage(group)}
				>
					{group.name}
				</button>
			),
		},
		{
			key: "employees",
			header: this.props.t('groups.tabs.employees'),
			className: "td-employees",
			sortAccessor: (group) =>
				this.getGroupEmployeeSummary(group).total_employees,
			render: (group) => {
				const { employees_avatars, empleados_count, total_employees } =
					this.getGroupEmployeeSummary(group);
				return (
					<div className="avatar-container">
						{total_employees > 0 && <Avatars employees={employees_avatars} />}
						{empleados_count}
					</div>
				);
			},
		},
		{
			key: "calendar",
			header: this.props.t('groups.form.calendar'),
			className: "td-calendar",
			sortAccessor: (g) =>
				g.calendar && g.calendar.name ? g.calendar.name : "",
			render: (group) => (group.calendar ? group.calendar.name : "—"),
		},
		{
			key: "subgroups",
			header: this.props.t('groups.title'),
			className: "td-groups",
			sortable: false,
			render: (group) =>
				group.is_multigroup ? (
					<ul className="list-tags">{this.getGroupList(group)}</ul>
				) : null,
		},
		{
			key: "color",
			header: "\u00A0",
			className: "td-icon",
			sortable: false,
			render: (group) => (
				<span
					className="bolita"
					style={{ backgroundColor: group.color && group.color }}
				/>
			),
		},
	];

	getRowsMobile = () =>
		(this.props.groups || []).map((group) => {
			const { employees_avatars, empleados_count, total_employees } =
				this.getGroupEmployeeSummary(group);

			return (
				<tr key={group.id}>
					<td>
						<div className="group-head">
							<button
								type="button"
								className="btn-transparent btn-editable group-name"
								onClick={() => this.openViewGroupPage(group)}
							>
								{group.name}
							</button>
							{group.calendar && (
								<div className="calendar-container">
									<FiCalendar /> <span>{group.calendar.name}</span>
								</div>
							)}
						</div>
						<div className="flex-between">
							<div className="avatar-container">
								{total_employees > 0 && (
									<Avatars employees={employees_avatars} />
								)}
								{empleados_count}
							</div>
							<span
								className="bolita m0"
								style={{ backgroundColor: group.color && group.color }}
							/>
						</div>

						{group.is_multigroup && (
							<ul className="list-tags mt10">{this.getGroupList(group)}</ul>
						)}
					</td>
					<td className="td-actions">{this.getActions(group)}</td>
				</tr>
			);
		});

	getActions = (group) => (
		<Dropdown>
			<Dropdown.Toggle variant="action">
				<FiMoreHorizontal />
			</Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item as="button" onClick={() => this.goToPlanning(group)}>
					{this.props.t('groups.list.goToPlanning')}
				</Dropdown.Item>
				<Dropdown.Item
					as="button"
					onClick={() => this.openViewGroupPage(group)}
				>
					{this.props.t('groups.list.detail')}
				</Dropdown.Item>
				<Dropdown.Item
					as="button"
					onClick={() => this.openEditGroupModal(group)}
				>
					{this.props.t('common.edit')}
				</Dropdown.Item>
				<Dropdown.Item
					as="button"
					onClick={() => this.openDeleteGroupModal(group.id)}
				>
					{this.props.t('common.delete')}
				</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);

	render() {
		const groups = this.props.groups || [];
		const {
			hasMore = false,
			loadingMore = false,
			fetchMore,
			scrollTargetId = "groups-infinite-scroll-target",
		} = this.props;

		const infiniteCommon = {
			dataLength: groups.length,
			next: fetchMore || (() => {}),
			hasMore,
			loader: loadingMore ? (
				<div className="text-center py-2 groups-infinite-loader">
					{this.props.t("common.loading")}
				</div>
			) : null,
			endMessage:
				groups.length > 0 && !hasMore ? (
					<p className="no-more-results text-center groups-infinite-end">
						{this.props.t("common.noMoreResults")}
					</p>
				) : null,
			scrollThreshold: 0.9,
		};

		return (
			<>
				<Mobile>
					<InfiniteScroll {...infiniteCommon}>
						<div className="table-mobile-container">
							<table className="table table-groups table-mobile">
								<tbody>
									{groups.length === 0
										? this.getEmptyRow(true)
										: this.getRowsMobile()}
								</tbody>
							</table>
						</div>
					</InfiniteScroll>
				</Mobile>
				<TabletOrDesktop>
					<div className="groups-list-container">
						<DataTable
							className="groups-datatable-scroll"
							scrollContainerId={scrollTargetId}
							scrollContainerClassName="groups-infinite-scroll-wrap"
						tableClassName="table-groups table-hover"
						tableStyle={{ backgroundColor: "#ffffff" }}
						columns={this.getDesktopColumns()}
						rows={groups}
						rowKey={(row) => row.id}
						emptyMessage={this.props.t('groups.noGroupsCreated')}
						actionsColumn={{
							render: (group) => this.getActions(group),
							className: "td-actions",
						}}
						infiniteScroll={{
							...infiniteCommon,
							scrollableTarget: scrollTargetId,
						}}
					/>
					</div>
				</TabletOrDesktop>
			</>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
});

export default compose(
	withRouter,
	connect(null, mapDispatchToProps),
	withTranslation()
)(GroupList);
